import React, {useState} from 'react'
import header from './Header.module.scss'
import logo from '../../image/Header/logo.png'
import HeaderContact from '../HeaderContact/HeaderContact'

const Header = ({isOpen, isOpenMenu}) => {

    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 10){
            setVisible(true)
        } 
        else if (scrolled <= 10){
            setVisible(false)
        }
    }

    window.addEventListener('scroll', toggleVisible);

    return (
        <header className={`${header.header} ${visible && header.header_scroll}`}>
        <div className={header.box}>
                <div className={header.info}>
                    <div className={header.box_logo}>
                        <a className={header.logo_link} href='initial'>
                            <img className={header.logo} src={logo} alt = 'логотип'/>
                        </a>
                        <HeaderContact
                            isOpen={isOpen}
                            visible={visible}
                            isOpenMenu={isOpenMenu}
                        />
                    </div>
                </div>
        </div>
    </header>    
    );
};

export default Header